<template lang="html">
  <transition name="wipe">
    <div class="sticky" ref="sticky" v-show="builderMode">
      <CreateOutfit ref="outfitBuildreComponentRef" />
      <div class="create-outfit-actions float-right mt-2">
        <b-button
          variant="link"
          class="cancel-link action-btn"
          @click="cancelOutfit()"
        >
          cancel
        </b-button>
        <b-button
          variant="unstitched"
          class="action-btn"
          @click="saveOutfit()"
          :disabled="!canSaveOutfit"
        >
          save
        </b-button>
      </div>
    </div>
  </transition>
</template>

<script>
import CreateOutfit from "@/components/wardrobe/clothes/CreateOutfit";
import { mapGetters } from "vuex";

export default {
  components: {
    CreateOutfit
  },

  computed: {
    ...mapGetters({
      builderMode: "wardrobeBuilderMode",
      builderOutfit: "builderOutfit"
    }),

    canSaveOutfit() {
      return this.builderOutfit.filter(obj => obj.product).length > 1;
    }
  },

  methods: {
    saveOutfit() {
      this.$refs.outfitBuildreComponentRef.submitCreateOutfit();
    },

    cancelOutfit() {
      this.$refs.outfitBuildreComponentRef.closeOutfitBuilder();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.sticky {
  position: sticky;
  top: 0;
  z-index: 1;
  height: 100%;
  margin-bottom: 50px;

  .create-outfit-actions {
    .action-btn {
      border-radius: 0;

      &:focus {
        box-shadow: none;
      }

      &.cancel-link {
        text-decoration: none;
        color: $primary-blue;

        &:hover {
          color: lighten($primary-blue, 45%);
        }
      }
    }
  }
}

.wipe-enter-active {
  animation: wipe-in 1s 1;
}

.wipe-leave-active {
  animation: wipe-out 1s 1;
}
@keyframes wipe-in {
  0% {
    transform: scale(0, 0.025);
  }
  50% {
    transform: scale(1, 0.025);
  }
}

@keyframes wipe-out {
  50% {
    transform: scale(1, 0.025);
  }

  100% {
    transform: scale(0, 0.025);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/clothes/CreateOutfitWrapper.vue